// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--EoUyD","close":"dd31006766--close--USPYW","left":"dd31006766--left--j6x4x","title":"dd31006766--title--_GEJb","text":"dd31006766--text--OXhPG"};